import { VStack, Icon, Text, Box, HStack, Button } from '@chakra-ui/react';
import {
  RiQrCodeLine,
  RiUserLine,
  RiThumbUpLine,
  RiWhatsappLine,
} from 'react-icons/ri';

interface StartChannelProps {
  onStart?: () => void;
  isLoading?: boolean;
}

export function StartChannel({ onStart, isLoading }: StartChannelProps) {
  return (
    <VStack gap={6} py={8} align="center" maxW="600px" mx="auto">
      <Icon as={RiWhatsappLine} boxSize={16} color="green.500" />
      <VStack gap={3} textAlign="center">
        <Text fontSize="2xl" fontWeight="bold">
          Connect Your WhatsApp Business Account
        </Text>
        <Text color="gray.600">
          Link your WhatsApp Business account to start communicating with your
          customers through WhatsApp.
        </Text>
      </VStack>

      <Box borderWidth="1px" borderRadius="lg" p={6} bg="gray.50" w="full">
        <VStack gap={4} align="start">
          <HStack gap={4}>
            <Icon as={RiQrCodeLine} boxSize={6} color="brand.primary" />
            <Box>
              <Text fontWeight="bold">Scan QR Code</Text>
              <Text fontSize="sm" color="gray.600">
                Use your phone to scan a QR code and connect your WhatsApp
                account
              </Text>
            </Box>
          </HStack>

          <HStack gap={4}>
            <Icon as={RiUserLine} boxSize={6} color="brand.primary" />
            <Box>
              <Text fontWeight="bold">Business Profile</Text>
              <Text fontSize="sm" color="gray.600">
                Set up your business profile and customize your channel settings
              </Text>
            </Box>
          </HStack>

          <HStack gap={4}>
            <Icon as={RiThumbUpLine} boxSize={6} color="brand.primary" />
            <Box>
              <Text fontWeight="bold">Start Messaging</Text>
              <Text fontSize="sm" color="gray.600">
                Begin sending and receiving messages through WhatsApp
              </Text>
            </Box>
          </HStack>
        </VStack>
      </Box>

      {onStart && (
        <Button
          colorPalette="green"
          size="lg"
          onClick={onStart}
          loading={isLoading}
        >
          <Icon as={RiQrCodeLine} />
          Start Connection
        </Button>
      )}

      <Text fontSize="sm" color="gray.500">
        By continuing, you agree to our Terms of Service and Privacy Policy
      </Text>
    </VStack>
  );
}
